export default __webpack_public_path__ + "static/media/Front.e98a5225.jpeg";